import React from 'react';
import PropTypes from 'prop-types';
import { domainService } from '../../domain/services/domainService';
import { urlService } from '../../domain/services/urlService';
import { getWords } from '../../domain/utils/stringUtils';
import { MPALink } from './MPALink';

export const SmartLink = ({
  to,
  native = false,
  className,
  target,
  onMouseOver,
  onMouseOut,
  onClick,
  // If you need an onClick event without navigation, use <Actionable> or set "native" true
  rel,
  hrefLang,
  children,
  title,
  'aria-label': ariaLabel,
  dataLayerClickEvent
}) => {
  if (to) {
    const linkProps = {};
    if (onClick) {
      linkProps.onClick = onClick;
    }
    if (className) {
      linkProps.className = className;
    }
    if (onMouseOver) {
      linkProps.onMouseOver = onMouseOver;
    }
    if (onMouseOut) {
      linkProps.onMouseOut = onMouseOut;
    }
    if (rel) {
      linkProps.rel = rel;
    }
    if (target) {
      linkProps.target = target;
    }
    if (hrefLang) {
      linkProps.hrefLang = hrefLang;
    }
    if (title) {
      linkProps.title = getWords(title, 16);
      linkProps['aria-label'] = title;
    }
    if (ariaLabel) {
      linkProps['aria-label'] = ariaLabel;
    }

    if (dataLayerClickEvent) {
      linkProps.onClick = e => {
        window.dataLayer.push(dataLayerClickEvent);
        if (onClick) {
          onClick(e);
        }
      };
    }

    // CASE 1: it contains an unknown domain, so it's external.
    if (urlService.isExternal(to) || target === '_blank') {
      linkProps.href = to;
      linkProps.rel = `${rel ? `${rel} ` : ''}noopener noreferrer nofollow`;
    } else {
      // Remove domain, so ongoing checks operate on a url without domain.
      linkProps.to = domainService.removeDomain(to);
      // Handle an edge case where to points to canonical domain without
      // a trailing slash ('https://www.nationalgeographic.es'), making linkProps.to
      // empty.
      if (linkProps.to === '') {
        linkProps.to = '/';
      }

      // CASE 2: transform into a native "<a href>" tag.
      if (native) {
        linkProps.href = linkProps.to;
        delete linkProps.to;
      }
    }

    // If linkProps.to is present, it is a MPA link
    return linkProps.to ? (
      <MPALink {...linkProps}>{children}</MPALink>
    ) : (
      <a {...linkProps}>{children}</a>
    );
  }
  return null;
};

SmartLink.propTypes = {
  to: PropTypes.string.isRequired,
  native: PropTypes.bool,
  className: PropTypes.string,
  target: PropTypes.string,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  onClick: PropTypes.func,
  rel: PropTypes.string,
  hrefLang: PropTypes.string,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  'aria-label': PropTypes.string,
  dataLayerClickEvent: PropTypes.objectOf(PropTypes.any)
};
